module.exports = __webpack_public_path__ + "img/home2E.42e11014.png";